<template>
  <div class="register-container">
    <h2>Register</h2>
    <form @submit.prevent="registerUser">
      <label for="email">Email:</label>
      <input
        id="email"
        v-model="email"
        type="email"
        required
      >

      <label for="password">Password:</label>
      <input
        id="password"
        v-model="password"
        type="password"
        required
      >

      <label for="role">Role:</label>
      <select
        id="role"
        v-model="role"
        required
      >
        <option value="trainer">
          Trainer
        </option>
        <option value="admin">
          Admin
        </option>
      </select>

      <button type="submit">
        Register
      </button>
    </form>
    <p
      v-if="errorMessage"
      class="error-message"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      class="success-message"
    >
      {{ successMessage }}
    </p>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'RegisterView',
  data() {
    return {
      email: '',
      password: '',
      role: 'trainer',
      errorMessage: '',
      successMessage: '',
    };
  },
  methods: {
    async registerUser() {
      try {
        // Send registration request to the backend
        const response = await axios.post('https://api.inventory.stafftraining.me/api/register', {
          email: this.email,
          password: this.password,
          role: this.role,
        });

        if (response.data.success) {
          this.successMessage = 'Registration successful! You can now log in.';
          this.errorMessage = '';
          this.clearForm();
        } else {
          this.errorMessage = response.data.message || 'Registration failed. Please try again.';
          this.successMessage = '';
        }
      } catch (error) {
        console.error('Registration error:', error);
        this.errorMessage = 'Registration failed. Please try again.';
        this.successMessage = '';
      }
    },
    clearForm() {
      this.email = '';
      this.password = '';
      this.role = 'trainer';
    },
  },
};
</script>

  <style scoped>
  .register-container {
    width: 300px;
    margin: 0 auto;
    text-align: center;
  }

  form {
    display: flex;
    flex-direction: column;
  }

  label, input, select, button {
    margin-bottom: 10px;
  }

  .error-message {
    color: red;
  }

  .success-message {
    color: green;
  }
  </style>
